import React, { useState, useEffect } from "react"
import useIsLogged from "utils/useIsLogged"
import "./TwoFactorAuthNoticePopup.scss"

/**
 * Announces the e-mail verification code step of the login
 * (starting 1 octombrie 2026). Shown only to logged in users
 * between the start and end dates, replacing the former
 * "Lichidare de stoc" popup.
 */
const TWO_FACTOR_AUTH_NOTICE_START = new Date("2026-09-25T00:00:00")
const TWO_FACTOR_AUTH_NOTICE_END = new Date("2026-10-01T08:00:00")

const STORAGE_KEY = "twoFactorAuthNoticeOct2026Dismissed"

const isTwoFactorAuthNoticeActive = () => {
  const now = new Date()
  return now >= TWO_FACTOR_AUTH_NOTICE_START && now <= TWO_FACTOR_AUTH_NOTICE_END
}

const TwoFactorAuthNoticePopup = () => {
  const [isVisible, setIsVisible] = useState(true)
  const isLogged = useIsLogged()

  useEffect(() => {
    const wasClosed = sessionStorage.getItem(STORAGE_KEY)
    if (wasClosed === "true") {
      setIsVisible(false)
    }
  }, [])

  if (!isTwoFactorAuthNoticeActive()) return null
  if (!isLogged) return null
  if (!isVisible) return null

  const handleClose = () => {
    setIsVisible(false)
    sessionStorage.setItem(STORAGE_KEY, "true")
  }

  return (
    <div className="two-factor-auth-notice-popup">
      <div className="two-factor-auth-notice-popup__header">
        <h4 className="two-factor-auth-notice-popup__title">
          Din 1 octombrie, autentificarea în Uniprest Instal Digital devine mai
          sigură.
        </h4>
        <button
          onClick={handleClose}
          className="two-factor-auth-notice-popup__close-button"
          title="Închide"
        >
          ×
        </button>
      </div>
      <div className="two-factor-auth-notice-popup__content">
        <p>
          După introducerea numelui de utilizator și a parolei, vei primi pe
          e-mail un cod de verificare pe care trebuie să îl introduci pentru a
          finaliza autentificarea. Codul este valabil 5 minute. Dacă nu îl
          primești, poți solicita unul nou după 1 minut.
        </p>
      </div>
    </div>
  )
}

export default TwoFactorAuthNoticePopup
